module.exports = __webpack_public_path__ + "img/font-plus.f1c24bc3.svg";